/**
 * ATT&CK enterprise technique name -> T-id, for the drill-in.
 *
 * attack/analytics keys techniques by NAME while get_mitre_technique_data
 * requires a T-id (captured 2026-08-22, docs/inventory/attack-capture.md),
 * so the bridge is this static framework map. Framework data, not tenant
 * data — names and ids are stable across ATT&CK releases at this
 * granularity. A name that is not here (tenant typos like "Data Encrypted
 * for Imapact", sub-technique composites, retired techniques) simply gets
 * no framework description in the drill-in; the tenant's own detections
 * still show.
 */
export const ATTACK_IDS: Record<string, string> = {
  'Abuse Elevation Control Mechanism': 'T1548',
  'Access Token Manipulation': 'T1134',
  'Account Access Removal': 'T1531',
  'Account Discovery': 'T1087',
  'Account Manipulation': 'T1098',
  'Acquire Infrastructure': 'T1583',
  'Active Scanning': 'T1595',
  'Adversary-in-the-Middle': 'T1557',
  'Application Layer Protocol': 'T1071',
  'Archive Collected Data': 'T1560',
  'Audio Capture': 'T1123',
  'Automated Collection': 'T1119',
  'Automated Exfiltration': 'T1020',
  'BITS Jobs': 'T1197',
  'Boot or Logon Autostart Execution': 'T1547',
  'Boot or Logon Initialization Scripts': 'T1037',
  'Browser Extensions': 'T1176',
  'Browser Session Hijacking': 'T1185',
  'Brute Force': 'T1110',
  'Clear Command History': 'T1070',
  'Cloud Service Discovery': 'T1526',
  'Command and Scripting Interpreter': 'T1059',
  'Compromise Accounts': 'T1586',
  'Container Administration Command': 'T1609',
  'Container and Resource Discovery': 'T1613',
  'Content Injection': 'T1659',
  'Create Account': 'T1136',
  'Create or Modify System Process': 'T1543',
  'Credentials from Password Stores': 'T1555',
  'Data Destruction': 'T1485',
  'Data Encoding': 'T1132',
  'Data Encrypted for Impact': 'T1486',
  'Data Manipulation': 'T1565',
  'Data Transfer Size Limits': 'T1030',
  'Data from Cloud Storage': 'T1530',
  'Data from Cloud Storage Object': 'T1530',
  'Data from Local System': 'T1005',
  'Data from Network Shared Drive': 'T1039',
  'Debugger Evasion': 'T1622',
  Defacement: 'T1491',
  'Deobfuscate/Decode Files or Information': 'T1140',
  'Disk Wipe': 'T1561',
  'Domain Trust Discovery': 'T1482',
  'Drive-by Compromise': 'T1189',
  'Dynamic Resolution': 'T1568',
  'Email Collection': 'T1114',
  'Encrypted Channel': 'T1573',
  'Endpoint Denial of Service': 'T1499',
  'Escape to Host': 'T1611',
  'Event Triggered Execution': 'T1546',
  'Exfiltration Over Alternative Protocol': 'T1048',
  'Exfiltration Over C2 Channel': 'T1041',
  'Exfiltration Over Physical Medium': 'T1052',
  'Exfiltration Over Web Service': 'T1567',
  'Exploit Public-Facing Application': 'T1190',
  'Exploitation for Client Execution': 'T1203',
  'Exploitation for Credential Access': 'T1212',
  'Exploitation for Defense Evasion': 'T1211',
  'Exploitation for Privilege Escalation': 'T1068',
  'Exploitation of Remote Services': 'T1210',
  'External Remote Services': 'T1133',
  'Fallback Channels': 'T1008',
  'File and Directory Discovery': 'T1083',
  'File and Directory Permissions Modification': 'T1222',
  'Financial Theft': 'T1657',
  Firmware: 'T1495',
  'Forced Authentication': 'T1187',
  'Forge Web Credentials': 'T1606',
  'Gather Victim Identity Information': 'T1589',
  'Gather Victim Network Information': 'T1590',
  'Hide Artifacts': 'T1564',
  'Hijack Execution Flow': 'T1574',
  'Impair Defenses': 'T1562',
  'Implant Internal Image': 'T1525',
  'Indicator Removal': 'T1070',
  'Indirect Command Execution': 'T1202',
  'Ingress Tool Transfer': 'T1105',
  'Inhibit System Recovery': 'T1490',
  'Input Capture': 'T1056',
  'Internal Spearphishing': 'T1534',
  'Lateral Tool Transfer': 'T1570',
  'Masquerading': 'T1036',
  'Modify Authentication Process': 'T1556',
  'Modify Registry': 'T1112',
  'Multi-Factor Authentication Interception': 'T1111',
  'Multi-Factor Authentication Request Generation': 'T1621',
  'Network Denial of Service': 'T1498',
  'Network Service Discovery': 'T1046',
  'Network Share Discovery': 'T1135',
  'Network Sniffing': 'T1040',
  'Non-Application Layer Protocol': 'T1095',
  'Non-Standard Port': 'T1571',
  'OS Credential Dumping': 'T1003',
  'Obfuscated Files or Information': 'T1027',
  'Obtain Capabilities': 'T1588',
  'Office Application Startup': 'T1137',
  'Password Policy Discovery': 'T1201',
  'Peripheral Device Discovery': 'T1120',
  'Permission Groups Discovery': 'T1069',
  Phishing: 'T1566',
  'Phishing for Information': 'T1598',
  'Pre-OS Boot': 'T1542',
  'Process Discovery': 'T1057',
  'Process Injection': 'T1055',
  'Protocol Tunneling': 'T1572',
  Proxy: 'T1090',
  'Query Registry': 'T1012',
  'Remote Access Software': 'T1219',
  'Remote Services': 'T1021',
  'Remote System Discovery': 'T1018',
  'Replication Through Removable Media': 'T1091',
  'Resource Hijacking': 'T1496',
  'Scheduled Task/Job': 'T1053',
  'Scheduled Transfer': 'T1029',
  'Screen Capture': 'T1113',
  'Search Open Websites/Domains': 'T1593',
  'Server Software Component': 'T1505',
  'Service Stop': 'T1489',
  'Software Deployment Tools': 'T1072',
  'Steal Application Access Token': 'T1528',
  'Steal Web Session Cookie': 'T1539',
  'Steal or Forge Authentication Certificates': 'T1649',
  'Steal or Forge Kerberos Tickets': 'T1558',
  'Subvert Trust Controls': 'T1553',
  'Supply Chain Compromise': 'T1195',
  'System Binary Proxy Execution': 'T1218',
  'System Information Discovery': 'T1082',
  'System Network Configuration Discovery': 'T1016',
  'System Network Connections Discovery': 'T1049',
  'System Owner/User Discovery': 'T1033',
  'System Services': 'T1569',
  'System Shutdown/Reboot': 'T1529',
  'Taint Shared Content': 'T1080',
  'Traffic Signaling': 'T1205',
  'Transfer Data to Cloud Account': 'T1537',
  'Trusted Relationship': 'T1199',
  'Unsecured Credentials': 'T1552',
  'Use Alternate Authentication Material': 'T1550',
  'User Execution': 'T1204',
  'Valid Accounts': 'T1078',
  'Video Capture': 'T1125',
  'Virtualization/Sandbox Evasion': 'T1497',
  'Web Service': 'T1102',
  'Windows Management Instrumentation': 'T1047',
}

/** T-id for a technique name, or null when the framework map has no entry. */
export function attackIdFor(name: string): string | null {
  return ATTACK_IDS[name.trim()] ?? null
}
